import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDragFileBrowseData, IReturnChangesWidgetEditForm, IWidgetReturnTranslatedValues, checkIfFieldDisabled, deepCopy, languagesList, languagesList_, widgetEditMode } from 'na-lib';
import { validColorValidator } from 'src/app/validators/color.validator';
import { Subject, takeUntil } from 'rxjs';
import { CommentsService } from 'src/app/service/comments.service';
import { ImageCompressionService } from 'src/app/service/image-compression.service';
import { LocalStorageService } from 'src/app/service/local-storage-service.service';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { supportUrlStructure } from 'src/app/supportUrls';
import { checkUrlProtocol, urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';

@Component({
    selector: 'app-product-registration-edit-form',
    templateUrl: './product-registration-edit-form.component.html',
    styleUrl: './product-registration-edit-form.component.css',
    standalone: false
})

export class ProductRegistrationEditFormComponent {
  @Input() data:widgetEditMode;//widgetTranslationModeData
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();
  registerProductForm!:FormGroup
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @Output() formChange = new EventEmitter<FormGroup>();

  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;

  productRegistrationData:any
  oldData:any
  languagesList = languagesList
  translationModeOriginal = false
  dragFileData: IDragFileBrowseData
  callToActionEditform!:FormGroup
  defaultLanguage:string
  widgetNumber:any
  passId:any
  url:any
  urlData:any
  imageUrl:string
  changes: boolean = false;
  noUrl: boolean = true;
  cardImg: boolean = false;
  invalid_backgroundColor=false
  invalid_foregroundColor=false
  invalid_borderColor=false
  dynamicUrl = false
  addUrl = false
  colorPalette: any[] = [];
  userHasBetaWidgetRole = false

  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private commentService: CommentsService,
    private imageCompressionService: ImageCompressionService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private settingsService: SettingsService,
    private uploadService: UploadService
  ) {
    this.imageUrl = './../../assets/img/default.jpg';
  }

  ngOnInit():void{
    if(this.settingsService.checkIfBetaRoleAccess())
    this.userHasBetaWidgetRole = true

    this.defaultLanguage = this.data.defaultLanguage
    this.productRegistrationData = deepCopy(this.data.values)
    this.oldData=this.productRegistrationData
    this.url=this.oldData.url
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    if(this.data.translateMode){
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.dragFileData = translateData.dragFileDataOriginal
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false

        this.dragFileData = translateData.dragFileData
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()

    this.initializePaletteColors();

  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){

    const {id, filter,type, name, registeredView, registered, unregistered, image , style, fallbackUrl , widgetStyle } = data;

    if(image?.url){
      this.cardImg = true
      this.urlData = supportUrlStructure(image.url, this.passId, this.settingsService.contextId$)
    }

    let registeredText = registered?.text, unregisteredText = unregistered?.text, altTitle = image?.altTitle
   
    if(!originalLanguageData){
      registeredText = valuesTranslated[selectedLanguage +'.'+id+'_registered.text']
      unregisteredText = valuesTranslated[selectedLanguage +'.'+id+'_unregistered.text']
      altTitle = valuesTranslated[selectedLanguage +'.'+id+'_image.altTitle']
    }

    this.checkdyanimcContentUrl(image?.url)

    if(image?.url){
      this.urlData = supportUrlStructure(image.url, this.passId, this.settingsService.contextId$)
      this.cardImg = true
    } 

    // Generate the key for localStorage
    const registeredViewKey = `registeredView_${this.passId}_${id}`;
    const storedRegisteredView = this.localStorageService.get(registeredViewKey);

    this.registerProductForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      type:[{value: type ? type :undefined, disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      name:[{value: name ? name : undefined, disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],

      registeredView: [{value: registeredView ? registeredView : storedRegisteredView, disabled: checkIfFieldDisabled('registeredView', fields, originalLanguageData)}],
      registeredShowImage:[{value: registered?.showImage ? registered?.showImage : undefined, disabled: checkIfFieldDisabled('registered.showImage', fields, originalLanguageData)}],
      registeredText:[{value: registeredText ? registeredText : undefined, disabled: checkIfFieldDisabled('registered.text', fields, originalLanguageData)}],
      registeredTextAlign:[{value: registered?.textAlign ? registered?.textAlign : undefined, disabled: checkIfFieldDisabled('registered.textAlign', fields, originalLanguageData)}],
      unregisteredShowImage:[{value: unregistered?.showImage ? unregistered?.showImage : undefined, disabled: checkIfFieldDisabled('unregistered.showImage', fields, originalLanguageData)}],
      unregisteredText:[{value: unregisteredText ? unregisteredText : undefined, disabled: checkIfFieldDisabled('unregistered.text', fields, originalLanguageData)}],
      imageUrl:[{value: image?.url ? image?.url : undefined, disabled: checkIfFieldDisabled('image.url', fields, originalLanguageData)}, [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]],
      imageDescription:[{value: image?.description ? image?.description : undefined, disabled: checkIfFieldDisabled('image.description', fields, originalLanguageData)}],
      imageSize:[{value: image?.size ? image?.size : undefined, disabled: checkIfFieldDisabled('image.size', fields, originalLanguageData)}],
      backgroundColor:[{value: style?.backgroundColor ? style?.backgroundColor : undefined, disabled: checkIfFieldDisabled('style.backgroundColor', fields, originalLanguageData)}, [validColorValidator()]],
      foregroundColor:[{value: style?.foregroundColor ? style?.foregroundColor : undefined, disabled: checkIfFieldDisabled('style.foregroundColor', fields, originalLanguageData)}, [validColorValidator()]],
      borderColor:[{value: style?.borderColor ? style?.borderColor : undefined, disabled: checkIfFieldDisabled('style.borderColor', fields, originalLanguageData)}, [validColorValidator()]],
      borderWidth:[{value: style?.borderWidth ? style?.borderWidth : undefined, disabled: checkIfFieldDisabled('style.borderWidth', fields, originalLanguageData)}],
      filter:[{value: filter ? filter : undefined, disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      altTitle:[{value: altTitle ? altTitle : undefined, disabled: checkIfFieldDisabled('image.altTitle', fields, originalLanguageData)}],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled: checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}],
      fallbackUrl:[{value: fallbackUrl ? fallbackUrl : undefined, disabled: checkIfFieldDisabled('image.fallbackUrl', fields, originalLanguageData)}, [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]]
    })

    this.checkInvalidColors()

    this.registerProductForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( value => {
      this.checkInvalidColors()

      if(!originalLanguageData){
        // this.returnChanges.emit({registeredText: value.registeredText, unregisteredText: value.unregisteredText, altTitle: value.altTitle})
        this.returnChanges.emit({
          type:this.data.type,
          form:this.registerProductForm, 
          validForm: this.registerProductForm.valid,
          translations:{registeredText: value.registeredText, unregisteredText: value.unregisteredText, altTitle: value.altTitle},
          errors:{invalid_backgroundColor:this.invalid_backgroundColor , invalid_borderColor:this.invalid_borderColor , invalid_foregroundColor:this.invalid_foregroundColor},
          saveDisabled: !this.registerProductForm.valid
        })
      }
    })

    this.registerProductForm.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.formChange.emit(this.registerProductForm);
    });

    this.registerProductForm.get('imageUrl')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async imageUrl => {
      this.checkdyanimcContentUrl(imageUrl)
      this.checkMissingImageSize()
    })

    this.registerProductForm.get('fallbackUrl')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async imageUrl => {
      this.checkPattern_url('fallbackUrl')
    })
  }

  initWidgetEdit(){
    const {id, filter,type, name, registeredView, registered, unregistered, image , style, fallbackUrl , widgetStyle } = this.productRegistrationData;

    this.checkdyanimcContentUrl(image?.url)

    if(image?.url){
      this.urlData = supportUrlStructure(image.url, this.passId, this.settingsService.contextId$)
      this.cardImg = true
    } 

    // Generate the key for localStorage
    const registeredViewKey = `registeredView_${this.passId}_${id}`;
    const storedRegisteredView = this.localStorageService.get(registeredViewKey);

    this.registerProductForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled:false}],
      type:[{value: type ? type :undefined, disabled:false}],
      name:[{value: name ? name : undefined, disabled:false}],
      registeredView: [{value: registeredView ? registeredView : storedRegisteredView, disabled:false}],
      registeredShowImage:[{value: registered?.showImage ? registered?.showImage : undefined, disabled:false}],
      registeredText:[{value: registered?.text ? registered?.text : undefined, disabled:false}],
      registeredTextAlign:[{value: registered?.textAlign ? registered?.textAlign : undefined, disabled:false}],
      unregisteredShowImage:[{value: unregistered?.showImage ? unregistered?.showImage : undefined, disabled:false}],
      unregisteredText:[{value: unregistered?.text ? unregistered?.text : undefined, disabled:false}],
      imageUrl:[{value: image?.url ? image?.url : undefined, disabled:false}, [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]],
      imageDescription:[{value: image?.description ? image?.description : undefined, disabled:false}],
      imageSize:[{value: image?.size ? image?.size : undefined, disabled:false}],
      backgroundColor:[{value: style?.backgroundColor ? style?.backgroundColor : undefined, disabled:false}, [validColorValidator()]],
      foregroundColor:[{value: style?.foregroundColor ? style?.foregroundColor : undefined, disabled:false}, [validColorValidator()]],
      borderColor:[{value: style?.borderColor ? style?.borderColor : undefined, disabled:false}, [validColorValidator()]],
      borderWidth:[{value: style?.borderWidth ? style?.borderWidth : undefined, disabled:false}],
      filter:[{value: filter ? filter : undefined, disabled:false}],
      altTitle:[{value: image?.altTitle ? image?.altTitle : undefined, disabled:false}],
      widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
      fallbackUrl:[{value: fallbackUrl ? fallbackUrl : undefined, disabled:false}, [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]]
    })

    this.registerProductForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( value => {
      this.checkInvalidColors()
      // if(!this.validColors && this.registerProductForm.valid)
      this.returnChanges.emit({
        type:this.data.type,
        form:this.registerProductForm, 
        validForm: this.registerProductForm.valid,
        data:value,
        errors:{invalid_backgroundColor:this.invalid_backgroundColor , invalid_borderColor:this.invalid_borderColor , invalid_foregroundColor:this.invalid_foregroundColor},
        saveDisabled: this.invalid_backgroundColor || this.invalid_borderColor || this.invalid_foregroundColor || !this.registerProductForm.valid
      })
    })

    this.registerProductForm.get('imageUrl')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async imageUrl => {
      this.checkdyanimcContentUrl(imageUrl)
      this.checkPattern_url('imageUrl')
      this.checkMissingImageSize()
    })

    this.registerProductForm.get('fallbackUrl')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async imageUrl => {
      this.checkPattern_url('fallbackUrl')
    })

    this.checkInvalidColors()

    this.dragFileData = {
      calledFrom: ProductRegistrationEditFormComponent,
      calledFromData:{
        passId: this.passId,
        widgetNumber:this.widgetNumber,
        widget: "callToAction",
      },
      enableDragDrop: true,
      enableBrowse:true,
      enableMedia:true,
      enableEnterUrl:true,
      enableMultipleDragDrop:false,
      supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
      supportedFileAccept:".jpg, .jpeg, .png, .webp",
      maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
      maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
      returnSupportUrl: undefined,
      returnUrlData: undefined,
      enterUrl:false,
      returnUrlType:undefined
    }
  }

  checkPattern_url(field){
    const fiedlValue:any = this.registerProductForm.get(field)
    if(fiedlValue){
      try{
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.registerProductForm.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "tridy:" || imgUrl.protocol === "context:" || imgUrl.protocol === "https:" || imgUrl.protocol === "http:" )
          this.registerProductForm.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);

          this.registerProductForm.updateValueAndValidity()
      }catch(e){}
    }
  }

  async checkMissingImageSize(){
    const { imageUrl, imageSize } = this.registerProductForm.value

    if(imageUrl && !this.dynamicUrl){
      if(imageSize?.length == 0 || (imageSize && imageSize[0] == 0 && imageSize[1] == 0) || !imageSize ){
        await this.uploadService.calculateImgFileSize(this.urlData).then(value => {
          this.registerProductForm.patchValue({imageSize: value})
        })
      }
    }
  }

  private initializePaletteColors(): void {
    const colors:any = [];
    const warmOrange = getComputedStyle(document.documentElement).getPropertyValue('--warmOrange');
    const darkBlue = getComputedStyle(document.documentElement).getPropertyValue('--darkBlue');
    const pureWhite = getComputedStyle(document.documentElement).getPropertyValue('--pureWhite');
    const neutral = getComputedStyle(document.documentElement).getPropertyValue('--neutral');
    colors.push(warmOrange, darkBlue, pureWhite, neutral);
    this.colorPalette = colors;
  }

  checkdyanimcContentUrl(value){
    if(value?.match(/\${(.+)\}/))
    this.dynamicUrl = true
    else
    this.dynamicUrl = false
  }

  checkInvalidColors(){
    if(this.registerProductForm.controls['backgroundColor'].hasError('invalidColor'))
      this.invalid_backgroundColor=true
    else
      this.invalid_backgroundColor=false
    
    if(this.registerProductForm.controls['foregroundColor'].hasError('invalidColor'))
      this.invalid_foregroundColor=true
    else
      this.invalid_foregroundColor=false
    
    if(this.registerProductForm.controls['borderColor'].hasError('invalidColor'))
      this.invalid_borderColor=true
    else
      this.invalid_borderColor=false
  }

  get validColors(){
    return this.invalid_backgroundColor || this.invalid_borderColor || this.invalid_foregroundColor
  }

  checkNewUrl(){
    this.url = this.registerProductForm.value.imageUrl
    this.urlData = supportUrlStructure(this.registerProductForm.value.imageUrl, this.passId, this.settingsService.contextId$)
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onImageError() {
    this.imageUrl = './../../assets/img/default.jpg';
  }

  deleteImg(x: any) {
    this.url = "";
    this.registerProductForm.patchValue({ imageUrl: this.url, imageDescription: "", imageSize:undefined, altTitle: undefined, fallbackUrl:undefined });
    this.urlData = "";
    this.cardImg = false;
  }

  typeURL(){
    this.addUrl = true
    this.urlData = './../../assets/img/default.jpg';
  }


  returnChangesFilters($event){
    this.registerProductForm.patchValue({filter: $event.newFilters})
  }

  returnChangesDragFileBrowseUI($event){
    if($event){
      const { returnSupportUrl,returnUrlData, enterUrl } = $event
      this.dragFileData = $event

      if(enterUrl){
        this.addUrl = true
        this.urlData = './../../assets/img/default.jpg'
      }else{
        this.addUrl = false
        this.urlData = undefined
      }

      if(returnUrlData)
        this.urlData = returnUrlData

      if(returnSupportUrl){
        this.imageUrl = returnSupportUrl
        this.url = returnSupportUrl
        this.cardImg = true;
        this.registerProductForm.patchValue({ imageUrl: returnSupportUrl })
      }
    }
  }

  returnChangesStyle($event){
    this.registerProductForm.patchValue({widgetStyle: $event.newStyle})
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
